import { PRODUCT_CATEGORIES } from '@/api/products/queries/get-product-query'
import { convertProductCategoryToUserFacingProductCategory } from '@/features/onboarding/helpers/user-facing-category-helpers'
import { PUBLIC_LANDING_ROUTES, UrlConfig } from '@/setup/routing/routing'

const toProductsHref = (category: (typeof PRODUCT_CATEGORIES)[keyof typeof PRODUCT_CATEGORIES]) =>
    UrlConfig['/products/[user_facing_product_category]'].getUrl({
        productCategory: convertProductCategoryToUserFacingProductCategory(category),
    })

export interface ISolutionItem {
    title: string
    subtitle: string
    href: string
    iconSrc?: string
}

export const SOLUTION_ITEMS_LEFT: ISolutionItem[] = [
    {
        title: 'Mobile App Ads',
        subtitle: 'Mobile app focused ads',
        href: toProductsHref(PRODUCT_CATEGORIES.APP),
    },
    {
        title: 'E-Commerce Ads',
        subtitle: 'E-com focused ads',
        href: toProductsHref(PRODUCT_CATEGORIES.E_COMMERCE),
    },
    {
        title: 'Website Ads',
        subtitle: 'Website-focused ads',
        href: toProductsHref(PRODUCT_CATEGORIES.OTHER),
    },
]

export const SOLUTION_ITEMS_RIGHT: ISolutionItem[] = [
    {
        title: 'Shopify Store',
        subtitle: 'E-com focused ads',
        href: PUBLIC_LANDING_ROUTES.SHOPIFY_STORE,
        iconSrc: '/icons/shopify.svg',
    },
    {
        title: 'Lovable Projects',
        subtitle: 'Marketing for your Lovable app',
        href: PUBLIC_LANDING_ROUTES.LOVABLE,
        iconSrc: '/assets/landing-page/lovable-logo.svg',
    },
    {
        title: 'Base44 Projects',
        subtitle: 'Marketing for your Base44 app',
        href: PUBLIC_LANDING_ROUTES.BASE44,
        iconSrc: '/assets/landing-page/base44-logo.svg',
    },
]

export const SOLUTION_ITEMS_CONTENT: ISolutionItem[] = [
    {
        title: 'AI UGC Ads',
        subtitle: 'High-performing AI UGC ads',
        href: PUBLIC_LANDING_ROUTES.AI_UGC_ADS,
    },
    {
        title: 'Static Ads',
        subtitle: 'Winning static ads with AI',
        href: PUBLIC_LANDING_ROUTES.STATIC_ADS,
    },
    {
        title: 'E-Commerce Assets',
        subtitle: 'Stunning e-com assets',
        href: PUBLIC_LANDING_ROUTES.E_COM_ASSETS,
    },
]

export const SOLUTION_ITEMS_INTEGRATION: ISolutionItem[] = [
    {
        title: 'Meta Ads',
        subtitle: 'Analyse & build Meta ads',
        href: PUBLIC_LANDING_ROUTES.INTEGRATIONS_META,
        iconSrc: '/icons/metaads.svg',
    },
    {
        title: 'TikTok Ads',
        subtitle: 'Analyse & build TikTok ads',
        href: PUBLIC_LANDING_ROUTES.INTEGRATIONS_TIKTOK,
        iconSrc: '/icons/tiktokads.svg',
    },
    {
        title: 'Google Ads',
        subtitle: 'Analyse & build Google ads',
        href: PUBLIC_LANDING_ROUTES.INTEGRATIONS_GOOGLE,
        iconSrc: '/icons/googleads.svg',
    },
]

export const ALL_SOLUTION_ITEMS: ISolutionItem[] = [
    ...SOLUTION_ITEMS_LEFT,
    ...SOLUTION_ITEMS_RIGHT,
    ...SOLUTION_ITEMS_CONTENT,
    ...SOLUTION_ITEMS_INTEGRATION,
]
